// extracted by mini-css-extract-plugin
module.exports = {"Link":"AuthFooter_Link__3IhXa"};